const modeKeys = [
  'VIEW',
  'EDIT',
  'SORT',
  'DELETE',
  'EDIT_NODE_BACKGROUND',
  'EDIT_NODE_LINK',
  'EDIT_NODE_BRANCH_BLOCK',
]

const modesObj = {}

modeKeys.forEach(mode => (modesObj[mode] = mode))

export const modes = Object.freeze(modesObj)

export function editor (platform) {
  const editor = {
    setEditorMode (mode) {
      platform.store.update(store => {
        store.editor.mode = mode

        return store
      })
    },
    currentMode () {
      return platform.storeData.editor.mode
    },
    isMode (modeKey) {
      if (modeKey === platform.storeData.editor.mode) {
        return true
      }

      return false
    },
    modes,
  }

  return editor
}
